var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dialogWrap"}},[_c('QrDialog',{ref:"qrDialog",attrs:{"title":"重置登录密码二维码","url":_vm.url,"content":"请使用手机扫码进行登录密码修改"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }